// *****************************************************************************
// Landing Module
// *****************************************************************************

document.addEventListener('DOMContentLoaded', () => {
  const landingModule = document.querySelector('.landing-module');
  if (!landingModule) return;

  const landingImages = document.querySelectorAll('.landing-module__image-inner');
  const getRandomDuration = (min, max) => Math.random() * (max - min) + min;

  if (landingImages.length) {
    const controller = new ScrollMagic.Controller();
    landingImages.forEach((image, index) => {
      image.style.transitionDuration = `${getRandomDuration(0.6, 1.2)}s`;

      const moveY = [1, 2, 4, 5, 7].includes(index) ? '50px' : '100px';

      const landingAnimationTween = gsap.to(image, { y: moveY, ease: 'none', paused: true });

      new ScrollMagic.Scene({
        triggerElement: landingModule,
        triggerHook: 0,
        duration: '100%',
      })
        .setTween(landingAnimationTween)
        .addTo(controller);
    });
  }

  // Wrap each word
  document.querySelectorAll('.word').forEach((word) => {
    const wrapper = document.createElement('span');
    wrapper.classList.add('word-wrapper');
    word.replaceWith(wrapper);
    wrapper.appendChild(word);
  });

  // Title animation

  setTimeout(() => {
    // Define the custom cubic-bezier easing
    CustomEase.create('customEase', '0.25, 1, 0.5, 1');

    const heroTimeline = gsap.timeline();

    heroTimeline.to('.landing-module__title .word', {
      y: 0,
      stagger: 0.083,
      ease: 'customEase',
      duration: 0.5,
    });

    heroTimeline.to(
      ['.landing-module__text--mobile', '.landing-module__button-item', '.landing-module__text-inner'],
      {
        y: 0,
        stagger: 0.083,
        ease: 'customEase',
        duration: 0.5,
      },
      '-=0.466',
    );

    heroTimeline.to(
      '.landing-module__image',
      {
        y: 0,
        opacity: 1,
        stagger: 0.083,
        ease: 'customEase',
        duration: 0.5,
      },
      '-=0.466',
    );
  }, 100);
});
